// 3rd party imports
import * as React from 'react';
import { useStores } from 'hooks';

import { observer } from 'mobx-react';

// bernie
import { DialogRoute, closeDialog } from 'bernie-core';
import { Layer } from 'bernie-view';

// shared-ui
import { ILocalization, LocalizedText } from '@shared-ui/localization-context';

// ui
import { UitkDialog, UitkDialogContent, UitkDialogFooter } from 'uitk-react-dialog';
import { UitkHeading, UitkParagraph } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { CommissionTable } from '../shared/commission-table';

import { Program } from 'models';

import { useHistory, useLocation } from 'react-router';

export interface PzInfoDialogProps {
  dialogId: string;
  l10n?: ILocalization;
}

export const PzInfoDialog: React.FunctionComponent<PzInfoDialogProps> = observer(({ dialogId, l10n }) => {
  const history = useHistory();
  const location = useLocation();
  const { context, user } = useStores();
  const { activeProgram } = user;

  const onDismiss = () => {
    closeDialog({ history, location, key: dialogId });
  };

  const { title, commissionPercentage, commissionType, cookieDurationDays, name } = activeProgram || {};

  const dialogContent = (
    <UitkDialogContent>
      <UitkHeading tag="h3" size={5}>
        <LocalizedText message={`pz.signup.dialog.${commissionType}.commission_rules`} data={[title]} />
      </UitkHeading>
      <UitkSpacing margin={{ blockstart: 'six' }}>
        <div>
          <UitkParagraph size={1}>
            <LocalizedText
              message={
                name === 'us-expedia'
                  ? `pz.signup.dialog.${commissionType}.commission.we_will_pay_you_through_partnerize.upto_commission`
                  : `pz.signup.dialog.${commissionType}.commission.we_will_pay_you_through_partnerize`
              }
              data={[commissionPercentage]}
            />
          </UitkParagraph>
          {name === 'us-expedia' && (
            <UitkSpacing margin={{ block: 'four' }}>
              <CommissionTable />
            </UitkSpacing>
          )}
          <UitkParagraph size={1}>
            <LocalizedText
              message={`pz.signup.dialog.${commissionType}.commission.the_guest_must_book_within_x_days`}
              data={[title, cookieDurationDays]}
            />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText message={`pz.signup.dialog.${commissionType}.commission.rental_amount`} />
          </UitkParagraph>
          <UitkParagraph size={1}>
            <LocalizedText message={`pz.signup.dialog.${commissionType}.commission.payout_is_subject_to_terms`} />
          </UitkParagraph>
        </div>
      </UitkSpacing>
    </UitkDialogContent>
  );

  return (
    <>
      <DialogRoute id={dialogId}>
        <Layer id="dialogPzInfo" onDismiss={onDismiss}>
          <UitkDialog returnFocusOnClose={true}>
            {dialogContent}
            <UitkDialogFooter
              key="UitkDialogFooter"
              stacked={true}
              buttonOne={{
                onClick: onDismiss,
                text: l10n.formatText('common.dialog.close'),
                type: 'tertiary',
              }}
            />
          </UitkDialog>
        </Layer>
      </DialogRoute>
    </>
  );
});
